import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CountryList from '../../CountryList';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';

import validate from './validate';
import messages from '../../../locale/messages';
import bt from '../../../components/commonStyle.css';
import s from '../Payout.css';

const PayoutBillingDetails = ({ handleSubmit }) => {

  const { formatMessage } = useIntl();

  const renderCountryList = ({ input, label, meta: { touched, error }, children, className }) => {
    return (
      <FormGroup className={bt.space4}>
        <label className={cx(bt.commonLabelText)}>{label}</label>
        <CountryList input={input} className={cx(className)} isEmptyFirst />
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </FormGroup>
    );
  }

  return (
    <div className={cx('inputFocusColor', 'commonListingBg', 'noMarginBottom')}>
      <form onSubmit={handleSubmit}>
        <h3 className={s.titleText}>{formatMessage(messages.addPayout)}</h3>
        <Field name="country" component={renderCountryList}
          className={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
          label={formatMessage(messages.country)}
        />
        <Field name="address1"
          component={InputFieldComponent}
          label={formatMessage(messages.address1)}
          inputClass={cx(bt.commonControlInput)}
          formGroupClass={bt.space4}
        />
        <Field name="address2"
          component={InputFieldComponent}
          label={formatMessage(messages.address2)}
          inputClass={cx(bt.commonControlInput)}
          formGroupClass={bt.space4}
        />
        <div className={s.displayGrid}>
          <Field name="city"
            component={InputFieldComponent}
            label={formatMessage(messages.city)}
            className={s.childOne}
            inputClass={cx(bt.commonControlInput)}
            formGroupClass={bt.space4}

          />
          <Field name="state"
            component={InputFieldComponent}
            label={formatMessage(messages.state)}
            className={s.childOne}
            inputClass={cx(bt.commonControlInput)}
            formGroupClass={bt.space4}
          />
        </div>
        <Field name="zipcode"
          component={InputFieldComponent}
          label={formatMessage(messages.zipCode)}
          inputClass={cx(bt.commonControlInput)}
          formGroupClass={bt.space4}
        />
        <div className='singleButtonFlexEnd'>
          <Button
            className={cx(bt.btnLarge, bt.btnPrimary)}
            type="submit"
          ><FormattedMessage {...messages.next} />
          </Button>
        </div>
      </form>
    </div>
  );
}

PayoutBillingDetails.propTypes = {
  handleSubmit: PropTypes.any.isRequired,
  formatMessage: PropTypes.any,
};

export default reduxForm({
  form: 'PayoutForm', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(withStyles(bt, s)(PayoutBillingDetails));